import React, {Component} from 'react';
import {Api} from '../../api';
import ButtonInput from '../../components/Common/ButtonInput'
import {getAuthToken} from '../../utils';
import {Modal} from '@material-ui/core';
import {connect} from 'react-redux';
import './PersonalData.scss';
import ButtonLink from "../../components/Common/ButtonLink";

class PersonalData extends Component {

    state = {
        paymentAmount: 0,
        certificateDate: {
            id: '',
            userId: '',
            name: '',
            taxNumber: '',
            country: '',
            validTill: '',
            //entity, role, userId, taxNumber, digitalSignatureType.certificateType, companyId
            companies: [],
        },
        ids: [],
        isLoading: true,
        isOpenModal: false,
        companyIdForDelete: -1,
    };


    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        const certificateId = this.props.match.params.certificateId;
        this.getCertificate();
    }

    getCertificate(certificateId) {
        this.props.handleLoader(true);
        let url = '';
        if (certificateId) {
            url = 'certificates?id=' + certificateId;
        } else {
            url = 'certificates';
        }
        const authToken = getAuthToken();
        console.log('Url is: ' + url);
        console.log(url);
        Api.get(url, authToken)
            .then((response) => {
                console.log(response.data.payload);
                let OSName = null;
                if (navigator.appVersion.indexOf("Win") != -1) OSName = "win";
                if (navigator.appVersion.indexOf("Mac") != -1) OSName = "mac";
                this.setState({
                    certificateDate: response.data.payload,
                    ids: response.data.ids,
                    isLoading: false,
                    OSName: OSName
                });
                this.props.handleLoader(false);
            }).catch((error) => {
            console.log('no companies');
            console.log(error.response);
            alert('Incorrect certificate id');
            this.props.handleLoader(false);
        });
    }

    pagination = (id) => {
        this.getCertificate(id);
    };

    render() {
        const {ids, certificateDate, isOpenModal, isLoading,OSName} = this.state;
        const expDate = new Date(certificateDate.validTill);
        return (!isLoading &&
            <div className="content">
                <div className="content-h2">Signature</div>
                <div className={'row'}>
                    <div className={'col-lg-5'}>
                        <div className={'row'}>
                            <div className={'col-lg-12'}>
                                <label className="field-hint-label">Name</label>
                            </div>
                            <div className={'col-lg-12'}>
                                <input className="payment-descr-input" type="text"
                                       disabled="true" value={certificateDate.name}/>
                            </div>
                        </div>
                    </div>
                    <div className={'col-lg-5 offset-lg-1'}>
                        <div className={'row'}>
                            <div className={'col-lg-12'}>
                                <label className="field-hint-label">Jurisdiction of incorporation</label>
                            </div>
                            <div className={'col-lg-12'}>
                                <input className="payment-descr-input" type="text"
                                       disabled="true"
                                       value={certificateDate.country === 'EE' ? 'Estonia' : certificateDate.country}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'row margin-top-25'}>
                    <div className={'col-lg-5'}>
                        <div className={'row'}>
                            <div className={'col-lg-12'}>
                                <label className="field-hint-label">Personal code</label>
                            </div>
                            <div className={'col-lg-12'}>
                                <input className="payment-descr-input" type="text"
                                       disabled="true" value={certificateDate.taxNumber}/>
                            </div>
                        </div>
                    </div>
                    <div className={'col-lg-5 offset-lg-1'}>
                        <div className={'row'}>
                            <div className={'col-lg-12'}>
                                <label className="field-hint-label">Expiration date</label>
                            </div>
                            <div className={'col-lg-12'}>
                                <input className="payment-descr-input" type="text"
                                       disabled="true" value={expDate.toLocaleDateString()}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'row companies-block'}>
                    <div className={'col-lg-12'}>
                        <div className="content-h2">Companies</div>
                    </div>
                    <div className={'col-lg-12'}>
                        <table className={'table company-table'}>
                            <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Company name</th>
                                <th scope="col">Role</th>
                                <th scope="col"></th>
                            </tr>
                            </thead>
                            <tbody>
                            {certificateDate.companies.map((company, index) => {
                                return (
                                    <tr key={index} className={0 === index ? 'first-row' : ''}>
                                        <td id={'taxNumber-' + index} className={0 === index ? 'first-row' : ''}>
                                            {company.taxNumber}
                                        </td>
                                        <td id={'name-' + index} className={0 === index ? 'first-row' : ''}>
                                            {company.entity}
                                        </td>
                                        <td id={'rol-' + index} className={0 === index ? 'first-row' : ''}>
                                            {company.role ? company.role : company.digitalSignatureType ? company.digitalSignatureType.certificateType : ''}
                                        </td>
                                        <td id={'del-' + index} className={0 === index ? 'first-row' : ''}>
                                            <div className="personal-data-delete"
                                                 onClick={() => this.setState({
                                                     isOpenModal: true,
                                                     companyIdForDelete: company.companyId
                                                 })}>Delete
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={'row button-block'}>
                    <div className={'col-lg-6'}>
                        {ids.length > 1 &&
                        <nav aria-label="">
                            <ul className="pagination pagination-lg">
                                {ids.map((id, index) => {
                                    return (
                                        <div>
                                            <li className={`page-item ${(id === certificateDate.id) && 'disabled'}`}>
                                                <a className="page-link"
                                                   onClick={(e) => this.pagination(id)}>{index + 1}</a>
                                            </li>
                                        </div>
                                    )
                                })}
                            </ul>
                        </nav>
                        }
                    </div>
                    {certificateDate.country === 'EE' &&
                    <div className={'col-lg-6'}>
                        <ButtonInput
                            id="add-entity-button"
                            className={'blue-button position-left'}
                            title='Add new company'
                            handleClick={this.onAddEntity}/>
                    </div>
                    }
                </div>
                {/*<div className={'row'}>*/}
                {/*</div>*/}
                <Modal
                    open={isOpenModal}
                    onClose={() => this.setState({isOpenModal: false})}>
                    <div className='modal-document-name delete-modal'>
                        <div className="fields-row m-b-20 body-title">
                            Are you sure?
                        </div>

                        <div className="fields-row actions-modal">
                            <ButtonInput className='dark-button transparent-btn-black'
                                         width='116'
                                         title='No'
                                         size='middle'
                                         handleClick={() => this.setState({isOpenModal: false})}/>
                            <ButtonInput className='dark-button blue-button m-0'
                                         width='116'
                                         title='Yes'
                                         size='middle'
                                         handleClick={() => this.onDeleteCompany()}/>
                        </div>
                    </div>
                </Modal>
            </div>


        )
    }

    onAddEntity = () => {
        const data = {certificateId: this.state.certificateDate.id};
        console.log(JSON.stringify(data));
        sessionStorage.setItem('company-create-mode-data', JSON.stringify(data));
        this.props.history.push('/user/personal-data/search-for-companies');
    };

    onDeleteCompany = () => {
        const authToken = getAuthToken();
        const {personalData, companyIdForDelete} = this.state;
        this.props.handleLoader(true);

        Api.deleteReq(`company?id=${companyIdForDelete}`, authToken).then((response) => {

            console.log(response, 'response delete');

            this.props.history.push('/user/personal-data/download-app');
        }).catch((error) => {
            console.log(error, 'error')
        })
    };
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(PersonalData);


// WEBPACK FOOTER //
// ./src/views/PersonalData/PersonalData.js